import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Model } from '../../../models/quotation-model/catalogs/quotation-model.model';
import { BaseInterface } from '../../../models/quotation-model/catalogs/base.model';
import { environment } from '../../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ModelService {
  URL_API = environment.apiURL;
  constructor(private http: HttpClient) {}

  getModels(brandId: number, year: number): Observable<Model[]> {
    return this.http.get<Model[]>(this.URL_API + '/Model?brandId=' + brandId + '&year=' + year);
  }

  getBrokers(): Observable<BaseInterface[]> {
    return this.http.get<BaseInterface[]>(this.URL_API + '/Model/GetQuoterBrokers');
  }
}
